module.exports = __webpack_public_path__ + "static/marriage-confidential-2cb7bb724e1eac057615f15036a11e51.jpg";